import { NgModule } from '@angular/core';

import { GCADASidebarComponent } from './sidebar.component';

@NgModule({
    declarations: [
        GCADASidebarComponent
    ],
    exports     : [
        GCADASidebarComponent
    ]
})
export class GCADASidebarModule
{
}
